import {
  require_highcharts
} from "./chunk-22FI7YQ2.js";
import "./chunk-AC2VUBZ6.js";
export default require_highcharts();
//# sourceMappingURL=highcharts.js.map
